import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Confirm() {
  const { t } = useTranslation();
  useEffect(() => {
    localStorage.removeItem('cart');
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-base)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1.5rem', fontFamily: "'Roboto', sans-serif", position: 'relative', overflow: 'hidden' }}>

      {/* Background watermark */}
      <div style={{ position: 'absolute', bottom: '5%', left: '50%', transform: 'translateX(-50%)', fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(4rem, 15vw, 10rem)', letterSpacing: '0.1em', color: 'var(--orange-glow)', whiteSpace: 'nowrap', pointerEvents: 'none', userSelect: 'none' }}>
        {t('confirm.confirmed')}
      </div>

      {/* Radial glow */}
      <div style={{ position: 'absolute', top: '40%', left: '50%', transform: 'translate(-50%, -50%)', width: '500px', height: '500px', borderRadius: '50%', background: 'radial-gradient(circle, var(--orange-glow) 0%, transparent 70%)', pointerEvents: 'none' }} />

      <div style={{ width: '100%', maxWidth: '480px', position: 'relative', zIndex: 1, textAlign: 'center' }}>

        {/* Success icon */}
        <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: 'linear-gradient(135deg, var(--orange), var(--orange-dark))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2.5rem', margin: '0 auto 2rem', boxShadow: '0 0 40px var(--shadow-orange)' }}>
          ✓
        </div>

        <h1 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(2.5rem, 7vw, 4rem)', letterSpacing: '0.08em', color: '#ffffff', marginBottom: '0.5rem' }}>
          {t('confirm.bookingConfirmed')}
        </h1>
        <div style={{ width: '50px', height: '3px', background: 'var(--orange)', borderRadius: '2px', margin: '0 auto 1.5rem' }} />

        <p style={{ fontSize: '0.92rem', color: 'var(--text-muted)', lineHeight: 1.7, marginBottom: '2.5rem', maxWidth: '360px', margin: '0 auto 2.5rem' }}>
          {t('confirm.bookingSuccessMessage')}
        </p>

        {/* Card */}
        <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '12px', padding: '2rem', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: 'linear-gradient(90deg, var(--orange-dark), var(--orange), var(--orange-light))' }} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
            <Link to="/profile" className="btn-orange" style={{ justifyContent: 'center', fontSize: '0.9rem' }}>
              {t('confirm.viewMyBookings')}
            </Link>
            <Link to="/" className="btn-outline-orange" style={{ justifyContent: 'center', fontSize: '0.9rem' }}>
              {t('confirm.backToHome')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
